module.exports = __webpack_public_path__ + "static/media/20ECE9.bd76cfe8.jpg";